import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'yuzhaiwu_collection';

function readCollection(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

export default function useCollection() {
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    setIds(readCollection());
  }, []);

  const persist = useCallback((next: string[]) => {
    setIds(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore storage errors
    }
  }, []);

  const isCollected = useCallback((id: string) => ids.includes(id), [ids]);

  const toggle = useCallback(
    (id: string) => {
      const current = readCollection();
      const next = current.includes(id) ? current.filter((v) => v !== id) : [...current, id];
      persist(next);
      return next.includes(id);
    },
    [persist],
  );

  return { ids, isCollected, toggle };
}